import PageTitle from "../components/PageTitle";

export default function CateringDetailsPage({ requestId }) {
  return (
    <main className="admin-page flex flex-column gap-5">
      <PageTitle eyebrow="Catering" title={`Catering Request #${requestId}`}>
        Full catering request details can be expanded here as quote models mature.
      </PageTitle>
    </main>
  );
}